export class LayerMenuItem {
  layerId: string;
  title: string;
  legend: string;
  visible:boolean;
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/models/layer-menu-item.model.ts